import { useEffect, useCallback } from 'react';

import PropTypes from 'prop-types';

const HeightUpdater = (props) => {
	const onWindowResize = useCallback(() => {
		const windowHeight = window.innerHeight;
		if (windowHeight !== props.height) {
			props.onHeightChange(windowHeight);
		}
	}, [props]);

	useEffect(() => {
		window.addEventListener('resize', onWindowResize);
		return () => {
			window.removeEventListener('resize', onWindowResize);
		};
	}, [onWindowResize]);

	return null;
};

HeightUpdater.propTypes = {
	height: PropTypes.number,
	onHeightChange: PropTypes.func
};

export default HeightUpdater;
